import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

import { Popover, IconButton, Typography, CardContent} from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help';
import PopupState, { bindTrigger, bindPopover} from 'material-ui-popup-state'

class TableCheckbox extends Component{
    constructor(props){
        super(props)
        this.state = {
            yesID: '',
            noID: '', 
            checked: false
        }
    }

    componentDidMount(){
        var yes, no;
        //Assuming always that two states, Checked and Unchecked, are the only ones that are available
        //this is neither flexible nor good
        //but here we are
        if(this.props.question.Answers[0].AnswerName == "Yes"){
            yes = this.props.question.Answers[0].AnswerId
            no = this.props.question.Answers[1].AnswerId
        } else {
            yes = this.props.question.Answers[1].AnswerId
            no = this.props.question.Answers[0].AnswerId
        }

        if(this.props.question.Responses[0].Response == yes){
            this.setState({
                checked:true
            })
        }

        this.setState({
            yesID: yes,
            noID: no
        })
    }

    handleChange = ev => {
        if(ev.target.checked){
            this.setState({
                checked:true
            })
            this.props.questionSetUpdateResponseValue(this.props.question.QuestionId, this.state.yesID)
        } else {
            this.setState({
                checked:false
            })
            this.props.questionSetUpdateResponseValue(this.props.question.QuestionId, this.state.noID)
        }
    }

    render(){
        if(this.props){
            var helpIcon = []
            if(this.props.question.QuestionHelpText.length){
                helpIcon = <PopupState variant="popover" popupId="help-popover">
                        {popupState => (
                            <span style={{float:'right', left:'-5px', width: '-1px', position:'relative', padding:'0', margin:'0'}}>

                            <IconButton aria-label="additional help text" variant="contained"  {...bindTrigger(popupState)} style={{color:'rgba(0,0,0,0.54)', padding:'2px', borderRadius:'50%'}}>
                                <HelpIcon style={{fontSize:'1.2rem'}}/>
                            </IconButton>
                            <Popover 
                                {...bindPopover(popupState)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'right',
                                }}
                                >
                                <Typography style={{maxWidth:'330px', padding:'10px'}} dangerouslySetInnerHTML={{__html:this.props.question.QuestionHelpText}}></Typography>
                            </Popover>
                            </span>
                        )}
                    </PopupState>
            }
            return(
                //<Radio>Answer</Radio>
                <TableRow>
                    
                    <TableCell component="th" scope="row">
                        {helpIcon}
                        {this.props.question.QuestionStandardContent}
                    </TableCell>
                    
                    <TableCell>
                        <Checkbox checked={this.state.checked} onChange={this.handleChange}></Checkbox>
                    </TableCell>
                </TableRow>
            )
        } else return <p>nope</p> 
        
    }
}

export default TableCheckbox;